import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { MASTER_DATA_FORM_FIELDS } from 'utils/constants'
import { getDepartment, getFamily, getSection } from 'utils/helpers'
const {
  ITEM_NUMBER,
  ACTIVE_ONLINE,
  BARCODE,
  DEPARTMENT,
  ERP_BRAND,
  ERP_ITEM_DESC,
  ERP_MARKETING_CODE,
  ERP_PACK_INFO,
  ERP_UOM,
  FAMILY,
  HIDE_AGGREGATORS,
  ONLINE_DESC,
  ONLINE_PACK_INFO,
  QTY_PER_UOM,
  SECTION,
  SUB_FAMILY,
  VAT_CLASS,
  VAT_PERCENTAGE,
} = MASTER_DATA_FORM_FIELDS

export const columns: ColDef[] = [
  {
    headerName: ITEM_NUMBER.label,
    field: ITEM_NUMBER.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: BARCODE.label,
    field: '_id',
    minWidth: 150,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: DEPARTMENT.label,
    field: DEPARTMENT.key,
    valueFormatter: (params: ValueFormatterParams) => {
      return getDepartment(params.value)
    },
  },
  {
    headerName: SECTION.label,
    field: SECTION.key,
    valueFormatter: (params: ValueFormatterParams) => {
      return getSection(params.value)
    },
  },
  {
    headerName: FAMILY.label,
    field: FAMILY.key,
    valueFormatter: (params: ValueFormatterParams) => {
      return getFamily(params.value)
    },
  },
  {
    headerName: SUB_FAMILY.label,
    field: SUB_FAMILY.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ERP_ITEM_DESC.label,
    field: ERP_ITEM_DESC.key,
    minWidth: 220,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ERP_UOM.label,
    field: ERP_UOM.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: QTY_PER_UOM.label,
    field: QTY_PER_UOM.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ERP_PACK_INFO.label,
    field: ERP_PACK_INFO.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ERP_BRAND.label,
    field: ERP_BRAND.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ERP_MARKETING_CODE.label,
    field: ERP_MARKETING_CODE.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: VAT_CLASS.label,
    field: VAT_CLASS.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: VAT_PERCENTAGE.label,
    field: VAT_PERCENTAGE.key,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value !== undefined ? `${params.value}%` : '-',
  },
  {
    headerName: ONLINE_DESC.label,
    field: ONLINE_DESC.key,
    minWidth: 220,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ONLINE_PACK_INFO.label,
    field: ONLINE_PACK_INFO.key,
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: ACTIVE_ONLINE.label,
    field: ACTIVE_ONLINE.key,
    cellRenderer: (params: ICellRendererParams) => {
      return params?.value === true
        ? 'Yes'
        : params?.value === false
          ? 'No'
          : '-'
    },
  },
  {
    headerName: HIDE_AGGREGATORS.label,
    field: HIDE_AGGREGATORS.key,
    minWidth: 350,
    // set auto height
    wrapText: true,
    autoHeight: true,
    valueFormatter: (params) => {
      return params.value || ''
    },
    cellRenderer: (params: ICellRendererParams) => {
      const aggregators =
        params.value && params.value?.length > 0
          ? params.value.filter((agg: any) => agg.isActive === true)
          : []
      return (
        <>
          {aggregators && aggregators?.length > 0 ? (
            <div className="flex h-full w-full max-w-3xl flex-wrap gap-3 py-4">
              {aggregators?.map((aggregator: any) => (
                <span
                  className="min-w-[30%] rounded-md bg-slate-200/70 px-2 py-1 text-xs text-gray-800"
                  key={`${aggregator?._id}^${params.data?._id}`}
                >
                  {aggregator?.aggregatorName}
                </span>
              ))}
            </div>
          ) : (
            '-'
          )}
        </>
      )
    },
  },
]
